import { observer } from 'mobx-react-lite';

import styles from './radial-gradient.module.scss';

export enum RadialBackgroundType {
  Primary = 'primary-background',
  Secondary = 'secondary-background',
}

export const RadialGradient = observer(({ backgroundType }: { backgroundType: RadialBackgroundType }) => {
  return <div className={`${styles.radialGradient} ${styles[backgroundType]}`}></div>;
});
